import { useMemo } from 'react'
import Icons from './Icons'

const REGISTER_LINK = 'https://www.jsqkmfytwpn.com/join/1p9999'

const footerLinks = {
  product: {
    title: '产品服务',
    links: [
      { label: '现货交易', href: REGISTER_LINK },
      { label: '合约交易', href: REGISTER_LINK },
      { label: '理财服务', href: REGISTER_LINK },
      { label: '质押挖矿', href: REGISTER_LINK },
    ],
  },
  support: {
    title: '帮助支持',
    links: [
      { label: '帮助中心', href: '/faq/' },
      { label: '费率说明', href: REGISTER_LINK },
      { label: 'API文档', href: REGISTER_LINK },
      { label: '安全指南', href: '/safety/' },
    ],
  },
  company: {
    title: '关于我们',
    links: [
      { label: '公司简介', href: REGISTER_LINK },
      { label: '加入我们', href: REGISTER_LINK },
      { label: '新闻动态', href: REGISTER_LINK },
      { label: '合作伙伴', href: REGISTER_LINK },
    ],
  },
  legal: {
    title: '法律合规',
    links: [
      { label: '用户协议', href: REGISTER_LINK },
      { label: '隐私政策', href: REGISTER_LINK },
      { label: '风险提示', href: REGISTER_LINK },
      { label: '合规声明', href: REGISTER_LINK },
    ],
  },
}

const allExternalLinks: Record<string, Array<{url: string; anchor: string; rel: string}>> = {
  '/': [
    { url: 'https://www.onehang.one/', anchor: '数字资产服务平台', rel: 'nofollow noopener' },
    { url: 'https://www.okb5.it.com/', anchor: '数字货币交易平台', rel: 'nofollow noopener' },
    { url: 'https://www.okxl.eu.cc/', anchor: '区块链资产入门', rel: 'nofollow noopener' },
    { url: 'https://www.xiaozi.cyou/', anchor: '加密资产市场指南', rel: 'nofollow noopener' },
    { url: 'https://www.okb5.cc/', anchor: '安全交易参考', rel: 'nofollow noopener' },
  ],
  '/guide/': [
    { url: 'https://www.okx7.gu.cc/', anchor: '平台使用帮助', rel: 'nofollow noopener' },
    { url: 'https://www.xiaozi.it.com/', anchor: '交易操作指南', rel: 'nofollow noopener' },
    { url: 'https://www.okai.boats/', anchor: '资产交易指引', rel: 'nofollow noopener' },
    { url: 'https://www.onehang.it.com/', anchor: '数字资产入门', rel: 'nofollow noopener' },
    { url: 'https://www.okb.it.com/', anchor: '交易工具参考', rel: 'nofollow noopener' },
  ],
  '/safety/': [
    { url: 'https://www.okb.us.cc/', anchor: '安全服务说明', rel: 'nofollow noopener' },
    { url: 'https://www.onehang.one/safety/', anchor: '资产保护参考', rel: 'nofollow noopener' },
    { url: 'https://www.okb5.it.com/safety/', anchor: '账户安全设置', rel: 'nofollow noopener' },
    { url: 'https://www.okxl.eu.cc/safety/', anchor: '数字资产风控', rel: 'nofollow noopener' },
    { url: 'https://www.xiaozi.cyou/safety/', anchor: '安全交易环境', rel: 'nofollow noopener' },
  ],
  '/compare/': [
    { url: 'https://www.okb5.cc/compare/', anchor: '交易类型分析', rel: 'nofollow noopener' },
    { url: 'https://www.okx7.gu.cc/compare/', anchor: '合约交易说明', rel: 'nofollow noopener' },
    { url: 'https://www.xiaozi.it.com/compare/', anchor: '现货市场参考', rel: 'nofollow noopener' },
    { url: 'https://www.okai.boats/compare/', anchor: '杠杆交易对比', rel: 'nofollow noopener' },
    { url: 'https://www.onehang.it.com/compare/', anchor: '交易策略参考', rel: 'nofollow noopener' },
  ],
  '/glossary/': [
    { url: 'https://www.okb.it.com/glossary/', anchor: '交易术语参考', rel: 'nofollow noopener' },
    { url: 'https://www.okb.us.cc/glossary/', anchor: '区块链名词解释', rel: 'nofollow noopener' },
    { url: 'https://www.onehang.one/glossary/', anchor: '加密货币词汇表', rel: 'nofollow noopener' },
    { url: 'https://www.okb5.it.com/glossary/', anchor: '交易基础概念', rel: 'nofollow noopener' },
    { url: 'https://www.okxl.eu.cc/glossary/', anchor: '数字资产术语', rel: 'nofollow noopener' },
  ],
  '/faq/': [
    { url: 'https://www.xiaozi.cyou/faq/', anchor: '交易问答汇总', rel: 'nofollow noopener' },
    { url: 'https://www.okb5.cc/faq/', anchor: '充值提现指南', rel: 'nofollow noopener' },
    { url: 'https://www.okx7.gu.cc/faq/', anchor: '账户问题解答', rel: 'nofollow noopener' },
    { url: 'https://www.xiaozi.it.com/faq/', anchor: '平台使用帮助', rel: 'nofollow noopener' },
    { url: 'https://www.okai.boats/faq/', anchor: '费率说明参考', rel: 'nofollow noopener' },
  ],
  '/start/': [
    { url: 'https://www.onehang.it.com/start/', anchor: '新手入门参考', rel: 'nofollow noopener' },
    { url: 'https://www.okb.it.com/start/', anchor: '数字货币教程', rel: 'nofollow noopener' },
    { url: 'https://www.okb.us.cc/start/', anchor: '交易学习指南', rel: 'nofollow noopener' },
    { url: 'https://www.onehang.one/start/', anchor: '加密资产入门', rel: 'nofollow noopener' },
    { url: 'https://www.okb5.it.com/start/', anchor: '新手交易参考', rel: 'nofollow noopener' },
  ],
}

export function Footer() {
  const externalLinks = useMemo(() => {
    const path = window.location.pathname.endsWith('/') ? window.location.pathname : window.location.pathname + '/'
    return allExternalLinks[path] || allExternalLinks['/']
  }, [])

  return (
    <footer className="relative overflow-hidden border-t border-[rgba(255,0,255,0.1)]">
      <div className="absolute inset-0 bg-[#0a0a0f]" />
      <div className="absolute inset-0 grid-pattern opacity-10" />

      <div className="relative z-10">
        <div className="section-padding border-b border-[rgba(255,0,255,0.1)]">
          <div className="max-w-4xl mx-auto text-center px-6">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              <span className="gradient-text">准备好开始了吗？</span>
            </h2>
            <p className="text-muted text-lg mb-8">
              加入全球5000万用户，在okb官网开启您的数字资产之旅
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href={REGISTER_LINK}
                target="_blank"
                rel="noopener"
                className="btn-primary inline-flex items-center justify-center gap-2"
              >
                立即注册
                <Icons.ArrowRight />
              </a>
              <a
                href="https://download.prhci.com/upgradeapp/android_1P9999.apk"
                target="_blank"
                rel="noopener"
                className="btn-secondary inline-flex items-center justify-center gap-2"
              >
                <Icons.Download />
                下载APP
              </a>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
            <div className="col-span-2 md:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <span className="text-2xl font-bold gradient-text">okb</span>
              </div>
              <p className="text-muted text-sm mb-4">
                全球领先的数字资产交易平台，为用户提供安全、专业、便捷的加密货币交易服务。
              </p>
              <div className="flex gap-4">
                <a
                  href={REGISTER_LINK}
                  target="_blank"
                  rel="noopener"
                  className="text-muted hover:text-[#ff00ff] transition-colors"
                >
                  <Icons.Twitter />
                </a>
                <a
                  href={REGISTER_LINK}
                  target="_blank"
                  rel="noopener"
                  className="text-muted hover:text-[#ff00ff] transition-colors"
                >
                  <Icons.Telegram />
                </a>
              </div>
            </div>

            {Object.values(footerLinks).map((section, index) => (
              <div key={index}>
                <h3 className="text-cyber-text font-semibold mb-4">{section.title}</h3>
                <ul className="space-y-2">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <a
                        href={link.href}
                        className="text-muted hover:text-[#ff00ff] transition-colors text-sm"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-[rgba(255,0,255,0.1)]">
          <div className="max-w-7xl mx-auto px-6 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 border-b border-[rgba(255,0,255,0.1)] pb-6 mb-6">
              <div className="flex flex-wrap items-center gap-x-6 gap-y-2" data-external-links>
                {externalLinks.map((l, i) => (
                  <a key={i} href={l.url} target="_blank" rel={l.rel} className="text-muted text-xs hover:text-cyber-text">{l.anchor}</a>
                ))}
              </div>
            </div>
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-muted text-sm">
                Digital asset trading involves significant risk. Please invest responsibly.
              </p>
              <div className="flex gap-6">
                <a
                  href={REGISTER_LINK}
                  target="_blank"
                  rel="noopener"
                  className="text-muted hover:text-cyber-text transition-colors text-sm"
                >
                  用户协议
                </a>
                <a
                  href={REGISTER_LINK}
                  target="_blank"
                  rel="noopener"
                  className="text-muted hover:text-cyber-text transition-colors text-sm"
                >
                  隐私政策
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
